<lib-page-layout>
  <lib-title-navbar
    pageHeader
    title="Szczegóły gierki"
    [showDots]="true"
    (onDotsClicked)="manageGame()"></lib-title-navbar>

  <div class="or-bg-white or-min-h-100-pc or-border-box">
    @if (gameDetails(); as game) {
      <div class="or-p-16-px">
        <lib-game-details
          [game]="game"
          [showHostInfo]="true"
          [showNavigateLink]="true"
          [showPhoneNumber]="showPhoneNumber()"
          (onSendMessage)="sendMessage($event)"
          [showGoToChat]="showGoToChat(game.gameParticipationStatus) || game?.isHost!">
          <ng-container *ngTemplateOutlet="paymentStatus"></ng-container>
        </lib-game-details>
      </div>

      @if (game.players?.length) {
        <ng-container
          *ngTemplateOutlet="playerList; context: { players: game.players, title: 'Lista graczy' }"></ng-container>
      }
      @if (game.playerApplications?.length) {
        <ng-container
          *ngTemplateOutlet="
            playerList;
            context: {
              players: game.playerApplications,
              title: 'Oczekujący na akceptację'
            }
          "></ng-container>
      }

      <ng-template #paymentStatus>
        @if (game.isPaid) {
          <div class="is-paid border-radius-8 is-paid or-head-sm or-p-4-px">Zapłacone</div>
        } @else {
          <div class="is-not-paid border-radius-8 is-paid or-head-sm or-p-4-px">Niezapłacone</div>
        }
      </ng-template>
    }
  </div>
  <lib-bottom-navbar pageFooter></lib-bottom-navbar>
</lib-page-layout>

<ng-template #playerList let-players="players" let-title="title">
  <div class="or-p-16-px">
    <div class="or-head-xs or-color-secondary-2 or-mb-12-px">{{ title }}</div>

    @for (player of players; track player.playerId ?? player.gamePlayerApplicationId ?? $index; let i = $index) {
      <div class="or-d-flex or-justify-content-between or-align-items-center">
        <div class="or-d-flex or-align-items-center" [redirectToUserProfile]="player.userId">
          <lib-or-avatar
            [avatarUrl]="player.userThumbnail"
            [initials]="player.userDisplayName"
            [avatarSize]="'sm'"></lib-or-avatar>

          <div class="or-head-sm text-no-wrap" [class.or-opacity-70]="!player.userId">
            {{ i + 1 }}.&nbsp;{{ player.userDisplayName }}
          </div>
          @if (player.playerPreferences?.preferredPosition === 'GOALKEEPER') {
            <or-icon name="gk" size="s" class="or-ml-8-px" />
          }
        </div>

        @if (player.userId && !shouldHideMessageIcon(player.userId)) {
          <or-icon
            name="contact"
            size="s"
            boxed
            class="or-color-white or-bg-main-1 or-mr-4-px"
            (click)="sendMessage({ userId: player.userId, displayName: player.userDisplayName })" />
        }
      </div>

      <div class="or-d-flex or-justify-content-center or-my-4-px">
        <div class="custom-divider-hosted-details or-my-4-px"></div>
      </div>
    }
  </div>
</ng-template>
